import "./css/software.css";

import TabNavItem from "../components/TabNavItem";
import TabContent from "../components/TabContent";
import "../components/Tabs.css";

import {
  faObjectGroup,
  faCog,
  faRocket,
  faHourglass,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import SubHeader from "../components/subHeader2";
import "./css/dropdown.css";
import dompurify from "dompurify";
import { useTranslation } from "react-i18next";
import i18next from "../config/lang/i18next";
import React, { useRef, useState, useEffect } from "react";
import Cookies from "universal-cookie";
import rtms from "./img/software/rtms.png";
import 개요1 from "./img/software/개요이미지1.png";
import 개요2 from "./img/software/개요이미지일까.png";
import ex4 from "./img/software/개요이미지.png";
import img1 from "./img/software/구성1.png";
import img2 from "./img/software/구성2.png";
import img3 from "./img/software/구성3.png";
import img4 from "./img/software/구성4.png";
import img5 from "./img/software/구성5.png";
import img6 from "./img/software/구성6.png";
import img7 from "./img/software/구성7.png";
import img8 from "./img/software/구성8.png";
import img9_구성 from "./img/software/구성9.png";

import img9 from "./img/software/구성9_2.png";

import module_OER from "./img/software/module_OER.png";
import module_worklist from "./img/software/module_worklist.png";
import module_세척기 from "./img/software/module_세척기.png";
import module_보관장 from "./img/software/module_보관장.png";
import workstation from "./img/software/workstation.png";
import 게이트웨이 from "./img/software/게이트웨이.png";

import raid from "./img/software/raid.png";
import print from "./img/software/print.png";
import database from "./img/software/database.png";
import monitor from "./img/software/monitor.png";
import eq from "./img/software/eq.png";
import disinfect from "./img/software/disinfect.png";
import scopemgt from "./img/software/scopemgt.png";
import hmi from "./img/software/hmi.png";

import arrow_down from "./img/icon/dropdown_arrow.png";

const cookies = new Cookies();

const options = ["개요", "구성요소", "기술문서"];

const Software = () => {
  const [activeTab, setActiveTab] = useState("개요");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("개요");

  const { t, i18n } = useTranslation();
  const sanitizer = dompurify.sanitize;
  const language = useRef(null);

  useEffect(() => {
    language.current = sessionStorage.getItem("language");
    if (language === null) {
      language.current = cookies.get("language");
    }
    i18next.changeLanguage(language.current);
  }, []);
  const toggling = () => setIsOpen(!isOpen);

  const onOptionClicked = (value) => () => {
    setSelectedOption(value);
    setIsOpen(false);
    console.log(selectedOption);
  };

  function reveal() {
    var fades = document.querySelectorAll(".animate_img");
    //var titles = document.querySelectorAll(".title-wrap");
    var reveals = document.querySelectorAll(".animate_text");
    for (var i = 0; i < fades.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = fades[i].getBoundingClientRect().top;
      var elementVisible = 50;
      if (elementTop < windowHeight - elementVisible) {
        fades[i].classList.add("visible");
      } else {
        fades[i].classList.remove("visible");
      }
    }

    for (var k = 0; k < reveals.length; k++) {
      var wH = window.innerHeight;
      var eT = reveals[k].getBoundingClientRect().top;
      var eV = 150;
      if (eT < wH - eV) {
        reveals[k].classList.add("visible");
      } else {
        reveals[k].classList.remove("visible");
      }
    }
  }
  window.addEventListener("scroll", reveal);

  reveal();

  return (
    <div className="wrapper">
      <style>
        {`
      
      .Tabs2{
        width:100%;
      }
   
   
      .grid_layout{
        max-width: 1320px;
      }
      .grid_layout > div {
        border: none;
      }
      .gridImg img{
        background:#eee;
        border-radius:50px;
        width:100%;
        height:100%;
        object-fit:contain;
      }
      .gridTxt{
        border:none;
        font-size:15px;
        text-align:center;
      }
      `}
      </style>
      <SubHeader />

      <div className="software">
        <div className="section_title">
          <h1 className="headerText">Software</h1>
        </div>

        <div className="">
          <div className="sw_wrap">
            <div className="sw_row">
              <img src={rtms} alt="ex1"></img>
              <div className="sw_txt_wrap">
                <div className="sw_main_txt">
                  <h1>GM G5000 RTMS</h1>
                  <h2>
                    Digital Real-time <br></br>Infection Control System
                  </h2>
                  <p>{i18next.t("software.summary")}</p>
                </div>
              </div>
            </div>
            <div className="Tabs2">
              <ul className="nav">
                <TabNavItem
                  title={i18next.t("software.tabs.overview.title")}
                  id="개요"
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                />
                <TabNavItem
                  title={i18next.t("software.tabs.composition.title")}
                  id="구성요소"
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                />
                <TabNavItem
                  title={i18next.t("software.tabs.table.title")}
                  id="기술문서"
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                />
              </ul>
              <div className="dropdown_container">
                <div className="dropdown_header" onClick={toggling}>
                  {selectedOption || "개요"}
                  <img src={arrow_down} alt="" />
                </div>
                <div
                  className={`dropdown_list_container ${
                    isOpen ? "active" : ""
                  }`}
                >
                  <div className="dropdown_list">
                    {options.map((option) => (
                      <div onClick={onOptionClicked(option)} key={Math.random()}>
                        <TabNavItem
                          title={option}
                          id={option}
                          activeTab={activeTab}
                          setActiveTab={setActiveTab}
                          
                        >
                          {option}
                        </TabNavItem>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <TabContent id="개요" activeTab={activeTab}>
                <div className="sw_desc">
                  <div>
                    <img
                      src={개요2}
                      alt="barcode"
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                    ></img>
                    <div className="sw_summary">
                      <div className="title">
                        <h1 style={{ textAlign: "center" }}>
                          Real-time Infection Control System
                        </h1>

                        <h5>
                          Gain greater control over the tasks required to run an
                          efficient, engaged business.
                        </h5>
                      </div>
                      <div className="features">
                        <div className="features_row">
                          <div className="feature">
                            <FontAwesomeIcon icon={faObjectGroup} />
                            <div className="ft_txt">
                              <h5>
                                {i18next.t(
                                  "software.tabs.overview.feature1.title"
                                )}
                              </h5>
                              <p>
                                {i18next.t(
                                  "software.tabs.overview.feature1.content"
                                )}
                              </p>
                            </div>
                          </div>
                          <div className="feature">
                            <FontAwesomeIcon icon={faHourglass} />
                            <div className="ft_txt">
                              <h5>
                                {i18next.t(
                                  "software.tabs.overview.feature2.title"
                                )}
                              </h5>
                              <p>
                                {i18next.t(
                                  "software.tabs.overview.feature2.content"
                                )}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="features_row">
                          <div className="feature">
                            <FontAwesomeIcon icon={faCog} />
                            <div className="ft_txt">
                              <h5>
                                {i18next.t(
                                  "software.tabs.overview.feature3.title"
                                )}
                              </h5>
                              <p>
                                {i18next.t(
                                  "software.tabs.overview.feature3.content"
                                )}
                              </p>
                            </div>
                          </div>
                          <div className="feature">
                            <FontAwesomeIcon icon={faRocket} />
                            <div className="ft_txt">
                              <h5>
                                {i18next.t(
                                  "software.tabs.overview.feature4.title"
                                )}
                              </h5>
                              <p>
                                {i18next.t(
                                  "software.tabs.overview.feature4.content"
                                )}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div>
                      <img
                        src={개요1}
                        alt="barcode"
                        className="animate_img"
                      ></img>
                    </div>
                    <div className="sw_txt animate_text">
                      <h3>
                        {i18next.t("software.tabs.overview.point1.title")}
                      </h3>
                      <p>
                        {i18next.t("software.tabs.overview.point1.content")}
                      </p>
                    </div>
                  </div>
                  <div className="row">
                    <div>
                      <img
                        src={img9}
                        alt="barcode"
                        className="animate_img"
                      ></img>
                    </div>
                    <div className="sw_txt animate_text">
                      <h3>
                        {i18next.t("software.tabs.overview.point2.title")}
                      </h3>
                      <p>
                        {i18next.t("software.tabs.overview.point2.content")}
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div>
                      <img
                        src={ex4}
                        alt="barcode"
                        className="animate_img"
                      ></img>
                    </div>
                    <div className="sw_txt animate_text">
                      <h3>
                        {i18next.t("software.tabs.overview.point3.title")}
                      </h3>
                      <p>
                        {i18next.t("software.tabs.overview.point3.content")}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="purple-to-blue-gradient-bg">
                  <div className="contact-container">
                    <div style={{ height: "90px" }} aria-hidden="true"></div>

                    <div className="contact-inner-container">
                      <div style={{ flexBasis: "70%" }}>
                        <h4 style={{ fontSize: "1.875rem" }}>
                        {i18next.t("contact1")}
                        </h4>

                        <p className="text-header" style={{ fontSize: "18px" }}>
                        {i18next.t("contact2")}
                        </p>
                      </div>

                      <div style={{ flexBasis: "30%" }}>
                        <div>
                          <a href="/inquiry">
                            <div
                              className="contact-block-button"
                              id="chatwithsales"
                              style={{
                                fontSize: "1.125rem",
                                textAlign: "center",
                                marginTop: "20px",
                                background:"white"
                            
                              }}
                            >
                              <i
                                className="fa fa-comments-o"
                                aria-hidden="true"
                              ></i>
                              {i18next.t("contact3")}
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{ height: "90px" }}
                      aria-hidden="true"
                      className="wp-block-spacer"
                    ></div>
                  </div>
                </div>
              </TabContent>
              <TabContent id="구성요소" activeTab={activeTab}>
                <div className="pDesc">
                  <div className="grid_layout">
                    <div style={{ width: "100%", height: "100%" }}>
                      <div className="gridImg">
                        <img src={img1} alt="ㅎㅎ"></img>
                      </div>
                      <div className="gridTxt">PACS GATEWAY</div>
                    </div>
                    <div style={{ width: "100%", height: "100%" }}>
                      <div className="gridImg">
                        <img src={img2} alt="ㅎㅎ"></img>
                      </div>
                      <div className="gridTxt">RTMS MODULE</div>
                    </div>
                    <div style={{ width: "100%", height: "100%" }}>
                      <div className="gridImg">
                        <img src={img9_구성} alt="ㅎㅎ"></img>
                      </div>
                      <div className="gridTxt">ENDOSCOPE REPROCESSOR</div>
                    </div>
                    <div style={{ width: "100%", height: "100%" }}>
                      <div className="gridImg">
                        <img src={img3} alt="ㅎㅎ"></img>
                      </div>
                      <div className="gridTxt">WORKSTATION SERVER</div>
                    </div>

                    <div style={{ width: "100%", height: "100%" }}>
                      <div className="gridImg">
                        <img src={img4} alt="ㅎㅎ"></img>
                      </div>
                      <div className="gridTxt">BARCODE SCANNER</div>
                    </div>
                    <div style={{ width: "100%", height: "100%" }}>
                      <div className="gridImg">
                        <img src={img5} alt="ㅎㅎ"></img>
                      </div>
                      <div className="gridTxt">RFID DETECTOR</div>
                    </div>
                    <div style={{ width: "100%", height: "100%" }}>
                      <div className="gridImg">
                        <img src={img6} alt="ㅎㅎ"></img>
                      </div>
                      <div className="gridTxt">CLIENT PROGRAM</div>
                    </div>

                    <div style={{ width: "100%", height: "100%" }}>
                      <div className="gridImg">
                        <img src={img7} alt="ㅎㅎ"></img>
                      </div>
                      <div className="gridTxt">USER ID HAND TAG / CARD TAG</div>
                    </div>
                    <div style={{ width: "100%", height: "100%" }}>
                      <div className="gridImg">
                        <img src={img8} alt="ㅎㅎ"></img>
                      </div>
                      <div className="gridTxt">ENDOSCOPE TAG</div>
                    </div>
                  </div>
                </div>
              </TabContent>
              <TabContent id="기술문서" activeTab={activeTab}>
                <div className="diagram">
                  <div className="title">GM MEDICAL RTMS SOLUTION DIAGRAM</div>
                  <section className="container">
                    <div className="container__sources">
                      <div className="source">
                        <img src={게이트웨이} alt="ㅎㅎ" />
                        <div className="label">
                          PACS GATEWAY (GM-G5000 RTMS){" "}
                        </div>
                      </div>

                      <div className="source">
                        <img src={module_worklist} alt="ㅎㅎ"></img>
                        <div className="label">WORKLIST MODULE BASE </div>
                      </div>
                    </div>
                    <div className="container__sources">
                      <div className="source">
                        <img src={module_세척기} alt="ㅎㅎ" />
                        <div className="label">WASHING MODULE BASE </div>
                      </div>

                      <div className="source">
                        <img src={module_OER} alt="ㅎㅎ"></img>
                        <div className="label">OER-AW MODULE BASE </div>
                      </div>

                      <div className="source">
                        <img src={module_보관장} alt="ㅎㅎ"></img>
                        <div className="label">
                          STORAGE CABINET MODULE BASE{" "}
                        </div>
                      </div>
                    </div>

                    <svg viewbox="0 0 10 100">
                      <line x1="5" x2="5" y1="0" y2="200" />
                    </svg>

                    <div className="container__middle">
                 
                      <h3>
                      {i18next.t(
                                  "software.tabs.table.feature1.content1"
                      )}
                      </h3>
                      <h3>
                      {i18next.t(
                                  "software.tabs.table.feature1.content2"
                      )}
                      </h3>
                    </div>

                    <svg viewbox="0 0 10 100">
                      <line x1="5" x2="5" y1="0" y2="200" />
                    </svg>

                    <div className="container__build">
                      <div className="source">
                        <img src={workstation} alt="ㅎㅎ"></img>
                        <div
                          className="label"
                          style={{ width: "300px", margin: "0 auto" }}
                        >
                          GM RTMS WORKSTATION{" "}
                        </div>
                      </div>

                      <div className="icons source">
                        <div className="icons1">
                          <div className="icon">
                            <img src={raid} alt="ㅎㅎ"></img>
                            <div>RAID 1</div>
                          </div>
                          <div className="icon">
                            <img src={print} alt="ㅎㅎ"></img>
                            <div>REPORT & PRINT</div>
                          </div>
                          <div className="icon">
                            <img src={database} alt="ㅎㅎ"></img>
                            <div>DATABASE</div>
                          </div>
                          <div className="icon">
                            <img src={monitor} alt="ㅎㅎ"></img>
                            <div>MONITORING</div>
                          </div>
                        </div>
                        <div className="icons2">
                          <div className="icon">
                            <img src={eq} alt="ㅎㅎ"></img>
                            <div>EQ RECIPE</div>
                          </div>
                          <div className="icon">
                            <img src={disinfect} alt="ㅎㅎ"></img>
                            <div>DISINFECTION MGT</div>
                          </div>
                          <div className="icon">
                            <img src={scopemgt} alt="ㅎㅎ"></img>
                            <div>SCOPE MGT</div>
                          </div>
                          <div className="icon">
                            <img src={hmi} alt="ㅎㅎ"></img>
                            <div>HMI</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </TabContent>
            </div>{" "}
            {/*Tab2 close*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Software;
